import { UntypedFormGroup, UntypedFormArray } from "@angular/forms";
import { ColDef, GridApi } from "ag-grid-community";
import { Subscription } from "rxjs";
import autoTable from 'jspdf-autotable';
import { constants } from "./constants";

export class Utility {

  public static getKey(jsonData: any, key: string, defaultValue: any) {
    if (jsonData && Object.keys(jsonData).length && key in jsonData) {
      return jsonData[key];
    }
    return defaultValue;
  }

  public static updateFieldStatus(formGroup: UntypedFormGroup, excludedList: any = ['productGroupName'], reset: boolean = true) {
    const isValid = formGroup.get('productGroupName')?.valid;
    let isEnable = false;
    if (isValid) {
      isEnable = true;
    }
    this.enableDisableControls(formGroup, excludedList, reset, isEnable);
  }

  public static enableDisableControls(formGroup: UntypedFormGroup, excludedList: any, reset: boolean, isEnable: boolean) {
    Object.keys(formGroup.controls).forEach(key => {
      if (!excludedList.includes(key)) {
        const formField = formGroup.get(key)
        if (reset) {
          formField?.reset();
        }
        if (isEnable) {
          formField?.enable();
        } else {
          formField?.disable();
        }
        const isArray = (<UntypedFormArray>formField)?.controls;
        if (isArray) {
          for (let i = 0; i < isArray.length; i++) {
            const childFormGroup = <UntypedFormGroup>isArray[i];
            this.enableDisableControls(childFormGroup, excludedList, reset, isEnable);
          }
        }
      }
    })
  }

  public static setGridHeight(api: GridApi | undefined, element_id: string, nRows: number, maxLength: number) {
    let ele = document.getElementById(element_id);
    if (nRows > maxLength) {
      // we could also call setDomLayout(null or undefined) here as normal is the default
      api?.setDomLayout('normal');
      ele && (ele.style.height = 32 + (28 * maxLength) + 'px');
    } else {
      api?.setDomLayout('autoHeight');
      ele && (ele.style.height = '');
    }
  }

  public static unsubscribeSubscriptionOnDestroy(subscriptions: any) {
    for (let i = 0; i < subscriptions.length; i++) {
      const subscription: Subscription = subscriptions[i];
      if (subscription) {
        subscription.unsubscribe();
      }
    }
  }

  public static isSelectedProductValid(event: Event, productGroupList: any, data: any, form: any, previousSelection: string) {
    const selectedId = Number((<HTMLSelectElement>event.target)?.value);
    const selectedIndex = (<HTMLSelectElement>event.target)?.selectedIndex - 1;
    const selectedProductGroup = productGroupList[selectedIndex];

    if (selectedProductGroup && selectedId !== selectedProductGroup['id']) {
      alert('Incorrect index and id. Something went wrong');
      return null;
    }

    const isExisting = this.isValueExistingInData(selectedId, data, 'product_grp_id');;
    if (isExisting) {
      form.controls['productGroupName'].setValue(previousSelection);
      alert('Data for the selected product group already exists');
      return null;
    }

    return selectedProductGroup;
  }

  public static isValueExistingInData(id: number, data: any, key: string) {
    for (let i = 0; i < data.length; i++) {
      if (data[i][key] === id) {
        return data[i];
      }
    }
    return undefined;
  }

  public static updateListByProdGroupId(allDataList: any, selectedProductId: any) {
    const selectedItemList : any = [];
    for (let i = 0; i < allDataList.length; i++) {
      if (selectedProductId === allDataList[i]['product_grp_id']) {
        selectedItemList.push(allDataList[i]);
      }
    }
    return selectedItemList;
  }

  public static getSelectedDataFromList(event: Event, dataList: any) {
    const selectedId = Number((<HTMLSelectElement>event.target)?.value);
    const selectedIndex = (<HTMLSelectElement>event.target)?.selectedIndex - 1;
    const selectedData = dataList[selectedIndex];
    if (selectedData && selectedId !== selectedData['id']) {
      alert('Incorrect index and id. Something went wrong');
      return null;
    }
    return selectedData;
  }

  public static getSelectedIndexFromDataListValue(event: Event, dataListId: string) {
    const value = (<HTMLInputElement>event.target)?.value || '';
    if (!value) { 
      return '';
    }
    const dataListElement = <HTMLElement>document.getElementById(dataListId);
    return dataListElement.querySelector('option[value="' + value + '"]')?.id || '';;
  }

  public static addFactorColumnDefinition(columnDefinition: ColDef[], factorValuesList: any) {
    const factorColumn: any = { headerName: '', field: '', suppressMovable: true, cellClass: 'grid-text', headerClass: 'grid-header'};
    for (let i = 0; i < factorValuesList.length; i++) {
      factorColumn['headerName'] = factorValuesList[i];
      factorColumn['field'] = 'mrpfactor_quantity_' + (i + 1);
      columnDefinition.push(JSON.parse(JSON.stringify(factorColumn)));
    }
  }

  public static getWorkflowStatesForProductGroup(id: number, allWorkflowList: any, isDict: boolean = false) {
    if (!allWorkflowList) {
      return [];
    }
    for (let i = 0; i < allWorkflowList.length; i++) {
      const workflow = allWorkflowList[i];
      if (workflow['product_grp_id'] === id) {
        if (isDict) {
          const dataList = [];
          const valueList = workflow['workflow_value'].split(',');
          const idsList = workflow['id'].split(',');
          for (let i = 0; i < idsList.length; i++) {
            dataList.push({'id': idsList[i], 'name': valueList[i]})
          }
          return dataList;
        }
        return workflow['id'].split(',')
      }
    }
    return [];
  }

  public static changeDatetimeToViewFormat(dataList: any) {
    for (let i = 0; i < dataList.length; i++) {
      if ('created_at' in dataList[i]) {
        const date = dataList[i].created_at.substring(0, 10) // yyyy-mm-dd format
        dataList[i].created_at = date.split("-").reverse().join("-") // dd-mm-yyyy format
      }
      if ('delivery_date' in dataList[i]) {
        const date = dataList[i].delivery_date.substring(0, 10) // yyyy-mm-dd format
        dataList[i].delivery_date = date.split("-").reverse().join("-") // dd-mm-yyyy format
      }
    }
  }

  public static getDataFromListById(id: number, dataList: any) {
    for (let i = 0; i < dataList.length; i++) {
      if (dataList[i]['id'] === id) {
        return dataList[i];
      }
    }
    return {};
  }

  public static printData(elementId: string = 'print-content', headerHeight: number = 120) {
    const printElementCloned = <HTMLElement>(<HTMLElement>document.getElementById(elementId)).cloneNode(true);
    let printSection = $('#printSection');
    if (printSection.length == 0) {
        printSection = $('<div id="printSection" style="width: 100%; height: 100%;"></div>')
        $('body').append(printSection);
    }
    printSection.append(printElementCloned);
    const headerSpaceEle = printSection.find('.page-header-space')[0]
    if (headerSpaceEle) {
      headerSpaceEle.style.height = headerHeight + 'px';
    }
    const headerEle = printSection.find('.page-header')[0];
    if (headerEle) {
      headerEle.style.position = 'fixed';
    }
    
    var toggleBody = $('body *:visible');
    toggleBody.hide();
    $('#printSection, #printSection *').show();
    window.print();
    printSection.remove();
    toggleBody.show();
  }

  public static printPdfData(doc: any, gridApi: any, columnDefs: ColDef[], fileNameStr: string, isLastRow: boolean = true) {
    const cols: any = [];
    const colsField: any = [];
    for (let i = 0; i < columnDefs.length; i++) {
      cols.push(columnDefs[i].headerName);
      colsField.push(columnDefs[i].field);
    }
    
    const rows: any = [];
    const rowsDisplayed = ((gridApi?.getModel()) as any).rowsToDisplay
    for (let i = 0; i < rowsDisplayed.length; i++) {
      const temp: any = [];
      temp.push(i + 1);
      for (let j = 1; j < colsField.length; j++) {
        temp.push(rowsDisplayed[i]['data'][colsField[j]])
      }
      rows.push(temp);
    }

    const footRow: any = [];
    if (isLastRow) {
      const pinnedBottomData = gridApi?.getPinnedBottomRow(0)?.data;
      footRow.push("");
      for (let j = 1; j < colsField.length; j++) {
        footRow.push(pinnedBottomData[colsField[j]])
      }
    }
    
    autoTable(doc, {
      theme: "grid",
      headStyles: constants.PDF_TABLE_HEAD_FOOT_STYLES,
      footStyles: constants.PDF_TABLE_HEAD_FOOT_STYLES,
      head: [cols], 
      body: rows,
      foot: [footRow],
      showFoot: "lastPage",
      margin: {
        top: 10,
        right: 5,
        bottom: 10,
        left: 5
      },
      startY: 22,
      styles: constants.PDF_TABLE_ROW_STYLES
    })
    // doc.output('dataurlnewwindow');
    const dateNow = new Date();
    const filename = fileNameStr +  dateNow.getDate()  + (dateNow.getMonth()+1) +  dateNow.getFullYear() + '.pdf';
    doc.save(filename);
  }

  public static updatePkgSlipTableColumns(factorValuesList: any, attributesList: any) {
    const columnNames: any = [];
    columnNames.push({columnName: 'Design Name', mrpField: false, field: 'design_name', footerValue: 'Total'});

    for (let i = 0; i < attributesList.length; i++) {
      const data = {columnName: attributesList[i]['name'], mrpField: false, field: 'attr_value_' + (i + 1), footerValue: ''}
      columnNames.push(data);
    }

    for (let i = 0; i < factorValuesList.length; i++) {
      const data = {columnName: factorValuesList[i], mrpField: 'mrpfactor_mrp_' + (i + 1), field: 'delivered_order_' + (i + 1), footerValue: ''}
      columnNames.push(data);
    }

    columnNames.push({columnName: 'QTY', mrpField: false, field: 'total_quantity', footerValue: 0});
    // columnNames.push({columnName: 'Amount', mrpField: false, field: 'total_mrp', footerValue: 0})
    
    return columnNames
  }

  public static setFooterValues(pkgColumnsData: any, totalQuantity: number) {
    // i-- loop so as to reduce loop counts
    for (let i = pkgColumnsData.length - 1; i > 0; i--) {
      if (pkgColumnsData[i]['field'] === 'total_quantity') {
        pkgColumnsData[i]['footerValue'] = totalQuantity;
        break; // break because total_quantity is the first field from start to update footer values
      }
      // if (pkgColumnsData[i]['field'] === 'total_mrp') {
      //   pkgColumnsData[i]['footerValue'] = totalMrp;
      // }
    }
  }

  public static removeItemFromArrayById(data: any, id: number) {
    for (let i = 0; i < data.length; i++) {
      if (data[i].id === id) {
        data.splice(i, 1);
        return;
      }
    }
  }

  public static getIdListFromDataList(data: any, key: string) {
    const keyList = [];
    for (let i = 0; i < data.length; i++) {
      keyList.push(data[i][key]);
    }
    return keyList;
  }

  public static setGridRowTotal(gridApi: any, rowIndex: string, columnId: string, factorValuesList: any, key: string, rowNode: any=undefined) {
    if (!rowNode) {
      rowNode = gridApi?.getRowNode(rowIndex);
      if (!rowNode) {
        alert('Row not found. Something went wrong.')
        return;
      }
    }
    let sum = 0;
    for (let i = 0; i < factorValuesList.length; i++) {
      const element = key + (i + 1);
      if (element in rowNode.data) {
        sum = sum + Number(rowNode.data[element]);
      }
    }
    rowNode?.setDataValue(columnId, sum);
  }

  public static updateRowData(gridApi: any) {
    const allRows : any = [];
    gridApi?.forEachNode(function (node: any) {
      allRows.push(node.data);
    });
    return allRows;
  }

}
